// removed by extract-text-webpack-plugin
module.exports = {"Lecture":"_12vfdGqF","Title":"_2MLXrZ4o","Footer":"_2glS6jHK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/lecture/lecture-component.styles.scss
// module id = 273
// module chunks = 0